import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  PDF_CLEAR_ALL_STATE,
  PDF_NAVIGATE_TO_SPECIFIC_PAGE,
} from '@app/libs/reactPdfJs/store/actionTypes';

type PdfLastNavigatePage = number;

const initialState: PdfLastNavigatePage = 0;

export default function reducer(state: PdfLastNavigatePage = initialState, action: PdfAction) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    case PDF_NAVIGATE_TO_SPECIFIC_PAGE:
      return action.payload;
    default:
      return state;
  }
}
